/**
 * Test Plugin - Bouncing Ball
 * Shows a bouncing ball on screen to confirm plugin is active
 */

import { nextTick } from 'vue';

export default {
  install(app) {
    console.log('🎾 [Test Plugin] Bouncing Ball loaded!');

    // Add bouncing ball to DOM after app mounts
    nextTick(() => {
      addBouncingBall();
    });
  }
};

function addBouncingBall() {
  const ball = document.createElement('div');
  ball.id = 'plugin-test-ball';
  ball.innerHTML = '⚽';
  ball.style.cssText = `
    position: fixed;
    font-size: 48px;
    z-index: 99999;
    cursor: pointer;
    transition: transform 0.2s;
  `;

  // Physics variables
  let x = Math.random() * (window.innerWidth - 60);
  let y = Math.random() * (window.innerHeight - 60);
  let vx = (Math.random() - 0.5) * 4; // Reduced from 8 to 4
  let vy = (Math.random() - 0.5) * 4; // Reduced from 8 to 4
  const gravity = 0.3; // Reduced from 0.5
  const bounce = 0.7; // Reduced from 0.8
  let rotation = 0; // Rotation angle in degrees
  
  // Mouse tracking for slowdown effect
  let mouseX = -1000;
  let mouseY = -1000;
  const slowdownRadius = 150; // Distance where slowdown starts
  
  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    // Calculate distance to mouse
    const dx = mouseX - (x + 30); // +30 for ball center
    const dy = mouseY - (y + 30);
    const distance = Math.sqrt(dx * dx + dy * dy);
    
    // Calculate slowdown factor based on distance
    let speedMultiplier = 1;
    if (distance < slowdownRadius) {
      speedMultiplier = distance / slowdownRadius; // 0 to 1
      speedMultiplier = Math.max(0.2, speedMultiplier); // Min 20% speed
    }
    
    // Apply gravity
    vy += gravity * speedMultiplier;

    // Update position with slowdown
    x += vx * speedMultiplier;
    y += vy * speedMultiplier;

    // Calculate rotation based on velocity (rolling effect)
    // The ball rotates based on horizontal movement
    rotation += vx * speedMultiplier * 2; // Multiply by 2 for more visible rotation

    // Bounce off walls
    if (x <= 0 || x >= window.innerWidth - 60) {
      vx *= -bounce;
      x = x <= 0 ? 0 : window.innerWidth - 60;
      
      // If ball is on the floor and hits a wall, give it a bounce
      if (y >= window.innerHeight - 70) {
        // Bounce impulse varies with horizontal speed, max 50
        const bounceImpulse = Math.min(50, Math.abs(vx) * 3);
        vy = -Math.abs(vy) - bounceImpulse;
      }
    }

    if (y <= 0 || y >= window.innerHeight - 60) {
      vy *= -bounce;
      y = y <= 0 ? 0 : window.innerHeight - 60;
      
      // Add random horizontal velocity on floor bounce
      if (y >= window.innerHeight - 60) {
        vx += (Math.random() - 0.5) * 1; // Reduced from 2 to 1
      }
    }

    // Apply position
    ball.style.left = `${x}px`;
    ball.style.top = `${y}px`;
    ball.style.transform = `rotate(${rotation}deg)`;

    requestAnimationFrame(animate);
  }

  let animationId = requestAnimationFrame(animate);

  // Hover effect
  ball.addEventListener('mouseenter', () => {
    ball.style.transform = `rotate(${rotation}deg) scale(1.3)`;
  });

  ball.addEventListener('mouseleave', () => {
    ball.style.transform = `rotate(${rotation}deg) scale(1)`;
  });

  // Click to disable plugin
  ball.addEventListener('click', async () => {
    try {
      const response = await fetch('/api/v1/plugins/example-bouncing-ball/disable', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅', data.message);
        // Animação de saída
        ball.style.transition = 'opacity 0.3s, transform 0.3s';
        ball.style.opacity = '0';
        ball.style.transform = 'scale(0)';
        setTimeout(() => {
          cancelAnimationFrame(animationId);
          ball.remove();
        }, 300);
      } else {
        const error = await response.json();
        console.error('❌ Erro ao desabilitar:', error);
      }
    } catch (error) {
      console.error('❌ Erro ao desabilitar plugin:', error);
    }
  });

  const style = document.createElement('style');
  style.textContent = `
    @keyframes bounce {
      0%, 100% { 
        top: 10px; 
        left: 10px;
      }
      25% { 
        top: 10px; 
        left: calc(100vw - 60px);
      }
      50% { 
        top: calc(100vh - 60px); 
        left: calc(100vw - 60px);
      }
      75% { 
        top: calc(100vh - 60px); 
        left: 10px;
      }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(ball);
  
  console.log('🎾 Ball is bouncing!');
}
